const sf = {
	key: 'sf',
	name: 'Silver&Fit',
	getDesignTokens: mode => ({
		mode,
		primary: {
			main: '#174f84',
			dark: '#00325a',
			light: '#eaf1ff',
			...(mode === 'dark' && {
				main: '#174f84',
				dark: '#00325a',
				light: '#eaf1ff',
			}),
		},
		secondary: {
			main: '#2979AF',
			dark: '#003351',
			light: '#d2e4ff',
			...(mode === 'dark' && {
				main: '#2979AF',
				dark: '#003351',
				light: '#d2e4ff',
			}),
		},
		tertiary: {
			main: '#ca3828',
			dark: '#690000',
			light: '#ffedea',
			...(mode === 'dark' && {
				main: '#ffbaaf',
				dark: '#330502',
				light: '#cc7b6f',
			}),
		},
	}),
};

export default sf;
